module.exports = __webpack_public_path__ + "img/ps-17.2a245875.jpg";